export default "__VITE_ASSET__BXX2hpOo__"